/**
 * Iter64 — Layout con sub-pestañas para el módulo Prospección.
 * Encapsula las 4 vistas: Pipeline (index), Histórico PLACE, Rastreo actual, Ranking gestoras.
 */
import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { Database, Activity, Trophy, ClipboardList } from 'lucide-react';

const TABS = [
  { to: '/prospeccion/historico', label: 'Histórico PLACE', icon: Database, testid: 'tab-prospeccion-historico' },
  { to: '/prospeccion/rastreo', label: 'Rastreo actual', icon: Activity, testid: 'tab-prospeccion-rastreo' },
  { to: '/prospeccion/gestoras', label: 'Ranking gestoras', icon: Trophy, testid: 'tab-prospeccion-gestoras' },
  { to: '/prospeccion/revision', label: 'Cola revisión', icon: ClipboardList, testid: 'tab-prospeccion-revision' },
];

export default function ProspeccionLayout() {
  return (
    <div className="space-y-5" data-testid="prospeccion-layout">
      <nav
        className="flex items-center gap-1 border-b border-ink-100 overflow-x-auto"
        data-testid="prospeccion-tabs"
      >
        {TABS.map(({ to, label, icon: Icon, end, testid }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={testid}
            className={({ isActive }) =>
              `inline-flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium whitespace-nowrap border-b-2 -mb-px transition ${
                isActive
                  ? 'border-brand-500 text-brand-600'
                  : 'border-transparent text-ink-500 hover:text-ink-800 hover:border-ink-200'
              }`
            }
          >
            <Icon className="w-4 h-4" />
            {label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}
